import React, { useState, useEffect, useContext, useRef } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  Android as AndroidIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import { TagsFilter } from "../TagsFilter";
import { QueuesFilter } from "../QueuesFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    background: theme.mode === "dark" ? "#0d0818" : "#f1f5f9",
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
    transition: "all 0.25s ease",
    fontWeight: 600,
    borderRadius: "8px",
    margin: "0 2px",
    opacity: 0.6,
    textTransform: "none",
    letterSpacing: "0.01em",
    "&.Mui-selected": {
      opacity: 1,
      color: "#5B2D8E",
      backgroundColor: "rgba(91,45,142,0.08)",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: "rgba(91,45,142,0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: "30%",
      fontSize: 10,
      padding: theme.spacing(0.5, 0.25),
    },
  },

  tabIndicator: {
    height: 3,
    bottom: 0,
    borderRadius: "3px 3px 0 0",
    background: "linear-gradient(135deg, #5B2D8E, #7C3AED)",
    transition: "all 0.3s ease",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },

  // ── TOOLBAR PRINCIPAL ────────────────────────────────────────────────
  toolbar: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    margin: "6px 8px 6px 8px",
  },

  // Fila 1: búsqueda
  searchRow: {
    display: "flex",
    alignItems: "center",
    height: 40,
    background: theme.mode === "dark" ? "rgba(15,23,42,0.85)" : "#fff",
    borderRadius: 10,
    border: "1px solid rgba(91,45,142,0.18)",
    padding: "0 6px 0 10px",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:focus-within": {
      borderColor: "#5B2D8E",
      boxShadow: "0 0 0 3px rgba(91,45,142,0.12)",
    },
  },

  searchIcon: {
    color: theme.mode === "dark" ? "#475569" : "#94a3b8",
    fontSize: 18,
    marginRight: 6,
    flexShrink: 0,
  },

  searchInput: {
    flex: 1,
    border: "none",
    background: "transparent",
    fontSize: 13,
  },

  searchToggle: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 6px",
    borderRadius: 6,
    cursor: "pointer",
    opacity: 0.65,
    transition: "opacity 0.2s",
    "&:hover": { opacity: 1 },
  },

  searchToggleActive: {
    opacity: 1,
    color: "#5B2D8E",
  },

  searchToggleLabel: {
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "inherit",
    whiteSpace: "nowrap",
  },

  filterBtn: {
    width: 30,
    height: 30,
    borderRadius: 8,
    flexShrink: 0,
    padding: 0,
    color: theme.mode === "dark" ? "#64748b" : "#94a3b8",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#5B2D8E",
      background: "rgba(91,45,142,0.08)",
    },
  },

  filterBtnActive: {
    color: "#5B2D8E",
    background: "rgba(91,45,142,0.10)",
  },

  // Fila 2: acciones + navegación + filtros
  actionsRow: {
    display: "flex",
    alignItems: "center",
    marginTop: 5,
    gap: 0,
  },

  // Zona izquierda: acción principal
  actionZone: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
  },

  newTicketBtn: {
    height: 32,
    padding: "0 12px !important",
    borderRadius: "8px !important",
    border: "none !important",
    background: "linear-gradient(135deg, #5B2D8E, #7C3AED) !important",
    color: "#fff !important",
    transition: "all 0.2s ease !important",
    flexShrink: 0,
    minWidth: "auto !important",
    "&:hover": {
      opacity: 0.88,
      transform: "translateY(-1px)",
      boxShadow: "0 4px 14px rgba(91,45,142,0.35)",
      background: "linear-gradient(135deg, #5B2D8E, #7C3AED) !important",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px !important",
      width: 32,
    },
  },

  // Zona central: vista principal (Abiertos / Resueltos)
  navZone: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    gap: 4,
    padding: "0 4px",
  },

  navPill: {
    height: 32,
    padding: "0 10px !important",
    borderRadius: "8px !important",
    border: "1px solid rgba(91,45,142,0.16) !important",
    background: "transparent !important",
    color: `${theme.mode === "dark" ? "#64748b" : "#94a3b8"} !important`,
    transition: "all 0.2s ease !important",
    whiteSpace: "nowrap",
    flexShrink: 0,
    minWidth: "auto !important",
    "&:hover": {
      borderColor: "#5B2D8E !important",
      color: "#5B2D8E !important",
      background: "rgba(91,45,142,0.06) !important",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 7px !important",
    },
  },

  navPillActive: {
    background: "linear-gradient(135deg, rgba(91,45,142,0.15), rgba(91,45,142,0.10)) !important",
    borderColor: "#5B2D8E !important",
    color: "#5B2D8E !important",
    boxShadow: "0 2px 8px rgba(91,45,142,0.18)",
  },

  navPillCount: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    borderRadius: 9,
    background: "rgba(91,45,142,0.18)",
    color: "#5B2D8E",
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 1,
  },

  navPillCountActive: {
    background: "#5B2D8E",
    color: "#fff",
  },

  navPillLabel: {
    [theme.breakpoints.down("sm")]: { display: "none" },
  },

  toolbarDivider: {
    width: 1,
    height: 22,
    background: "rgba(91,45,142,0.14)",
    flexShrink: 0,
    margin: "0 4px",
  },

  // Zona derecha: filtros secundarios
  filtersZone: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
  },

  iconFilterBtn: {
    width: 32,
    height: 32,
    borderRadius: "8px !important",
    border: "1px solid rgba(91,45,142,0.16) !important",
    flexShrink: 0,
    padding: "0 !important",
    background: "transparent !important",
    color: `${theme.mode === "dark" ? "#64748b" : "#94a3b8"} !important`,
    transition: "all 0.2s ease !important",
    "&:hover": {
      borderColor: "#5B2D8E !important",
      color: "#5B2D8E !important",
      background: "rgba(91,45,142,0.08) !important",
    },
    "& svg": { fontSize: 17 },
    [theme.breakpoints.down("sm")]: {
      width: 28,
      height: 28,
    },
  },

  iconFilterBtnActive: {
    borderColor: "#5B2D8E !important",
    color: "#5B2D8E !important",
    background: "rgba(91,45,142,0.10) !important",
  },

  iconFilterBtnDanger: {
    borderColor: "rgba(239,68,68,0.25) !important",
    color: "#ef4444 !important",
    "&:hover": {
      borderColor: "#ef4444 !important",
      background: "rgba(239,68,68,0.08) !important",
    },
  },

  queueSelectInline: {
    flexShrink: 0,
    minWidth: 80,
    maxWidth: 120,
    [theme.breakpoints.down("sm")]: {
      minWidth: 64,
      maxWidth: 96,
    },
  },

  // legado — mantener para no romper referencias
  serachInputWrapper: { display: "none" },
  searchRow2: {},
  badge: {},
  ticketOptionsBox: { display: "none" },
  optionsDivider: {},

  customBadge: {
    right: "-12px",
    top: "-10px",
    transform: "translate(30%, -30%)",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "10px",
    padding: "0 6px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },
  
  modernTabs: {
    minHeight: 48,
    borderRadius: 8,
    backgroundColor: theme.mode === "dark" ? "rgba(15,23,42,0.50)" : "rgba(0,0,0,0.02)",
    padding: "6px 4px 0 4px",
    margin: "4px 8px 0 8px",
    transition: "all 0.3s ease",
    position: "relative",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {},
  button: {},
  icon: {},
  buttonOpen: {},
  standardButton: {},
  activeButton: {},
  standardIcon: {},
  activeIcon: {},
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedQueues = (selecteds) => {
    const ids = selecteds.map((q) => q.id);
    setSelectedQueueIds(ids.length > 0 ? ids : userQueueIds);
    setForceSearch((f) => !f);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
      setSearchParam("");
      setSelectedTags([]);
      setSelectedUsers([]);
      setSelectedWhatsapp([]);
      setSelectedStatus([]);
      setSelectedQueueIds(userQueueIds);
      setForceSearch(!forceSearch);
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    } else {
      setFilter(true);
      setTab("search");
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      {/* ── TOOLBAR ─────────────────────────────────────────────── */}
      <div className={classes.toolbar}>

        {/* FILA 1 — Búsqueda */}
        <div className={classes.searchRow}>
          <SearchIcon className={classes.searchIcon} />
          <InputBase
            className={classes.searchInput}
            inputRef={searchInputRef}
            placeholder={i18n.t("tickets.search.placeholder")}
            type="search"
            onChange={handleSearch}
          />
          {/* Toggle buscar en mensajes */}
          <Tooltip title={searchOnMessages ? "Buscando en mensajes (lento)" : "Buscar también en mensajes"} placement="top">
            <div
              onClick={() => setSearchOnMessages((v) => !v)}
              style={{
                display: "flex", alignItems: "center", gap: 3,
                padding: "2px 7px", borderRadius: 6, cursor: "pointer", flexShrink: 0,
                border: searchOnMessages ? "1px solid #5B2D8E" : "1px solid transparent",
                background: searchOnMessages ? "rgba(91,45,142,0.10)" : "transparent",
                color: searchOnMessages ? "#5B2D8E" : (theme.mode === "dark" ? "#475569" : "#94a3b8"),
                transition: "all 0.2s", userSelect: "none",
              }}
            >
              <MessageSharpIcon style={{ fontSize: 14, color: "inherit" }} />
              {!isMobile && <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.04em", color: "inherit" }}>MSG</span>}
            </div>
          </Tooltip>
          {/* Filtros avanzados */}
          <Tooltip title={isFilterActive ? "Ocultar filtros" : "Filtros avanzados"} placement="top">
            <div
              onClick={() => { setIsFilterActive((p) => !p); handleFilter(); }}
              style={{
                width: 30, height: 30, borderRadius: 8, cursor: "pointer", flexShrink: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: isFilterActive ? "#5B2D8E" : (theme.mode === "dark" ? "#475569" : "#94a3b8"),
                background: isFilterActive ? "rgba(91,45,142,0.10)" : "transparent",
                transition: "all 0.2s",
              }}
            >
              {isFilterActive ? <FilterAlt style={{ fontSize: 18, color: "inherit" }} /> : <FilterAltOff style={{ fontSize: 18, color: "inherit" }} />}
            </div>
          </Tooltip>
        </div>

        {/* Filtros avanzados expandibles */}
        {filter === true && (
          <div style={{ marginTop: 4 }}>
            <TagsFilter onFiltered={handleSelectedTags} />
            <QueuesFilter userQueues={user?.queues} onFiltered={handleSelectedQueues} />
            <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
            <StatusFilter onFiltered={handleSelectedStatus} />
            {profile === "admin" && <UsersFilter onFiltered={handleSelectedUsers} />}
          </div>
        )}

        {/* FILA 2 — 3 zonas iguales: Izquierda | Centro | Derecha */}
        <div style={{ display: "flex", alignItems: "center", marginTop: 5, width: "100%" }}>

          {/* ── ZONA IZQUIERDA (flex:1, start) ── */}
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 4 }}>
            {user.profile === "admin" && (
              <Tooltip title="Cerrar todos los tickets" placement="bottom">
                <div
                  onClick={handleSnackbarOpen}
                  style={{
                    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                    height: 32, padding: "0 8px", borderRadius: 8, cursor: "pointer", gap: 1,
                    border: "1px solid rgba(239,68,68,0.25)", background: "transparent", color: "#ef4444",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(239,68,68,0.06)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                >
                  <PlaylistAddCheckOutlined style={{ fontSize: 14, color: "inherit" }} />
                  <span style={{ fontSize: 8, fontWeight: 700, color: "inherit", lineHeight: 1, whiteSpace: "nowrap" }}>Cerrar</span>
                </div>
              </Tooltip>
            )}
          </div>

          {/* ── ZONA CENTRAL (flex:1, center) — Abiertos / Resueltos ── */}
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>

            <Tooltip title="Tickets abiertos" placement="bottom">
              <div
                onClick={() => handleChangeTab(null, "open")}
                style={{
                  display: "flex", alignItems: "center", gap: 6,
                  height: 34, padding: isMobile ? "0 10px" : "0 14px",
                  borderRadius: 8, cursor: "pointer",
                  border: tab === "open" ? "1px solid #5B2D8E" : "1px solid rgba(91,45,142,0.18)",
                  background: tab === "open" ? "linear-gradient(135deg, rgba(91,45,142,0.15), rgba(91,45,142,0.10))" : "transparent",
                  color: tab === "open" ? "#5B2D8E" : (theme.mode === "dark" ? "#64748b" : "#94a3b8"),
                  boxShadow: tab === "open" ? "0 2px 8px rgba(91,45,142,0.18)" : "none",
                  transition: "all 0.2s", userSelect: "none",
                }}
                onMouseEnter={e => { if (tab !== "open") { e.currentTarget.style.borderColor = "#5B2D8E"; e.currentTarget.style.color = "#5B2D8E"; e.currentTarget.style.background = "rgba(91,45,142,0.06)"; }}}
                onMouseLeave={e => { if (tab !== "open") { e.currentTarget.style.borderColor = "rgba(91,45,142,0.18)"; e.currentTarget.style.color = theme.mode === "dark" ? "#64748b" : "#94a3b8"; e.currentTarget.style.background = "transparent"; }}}
              >
                <MoveToInboxIcon style={{ fontSize: 16, color: "inherit" }} />
                <span style={{ fontSize: 13, fontWeight: 600, color: "inherit", lineHeight: 1 }}>Abiertos</span>
                <span style={{
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  minWidth: 20, height: 20, padding: "0 6px", borderRadius: 10,
                  background: tab === "open" ? "#5B2D8E" : "rgba(91,45,142,0.18)",
                  color: tab === "open" ? "#fff" : "#5B2D8E",
                  fontSize: 11, fontWeight: 700, lineHeight: 1,
                }}>
                  {openCount + pendingCount + groupingCount}
                </span>
              </div>
            </Tooltip>

            <Tooltip title="Tickets resueltos" placement="bottom">
              <div
                onClick={() => handleChangeTab(null, "closed")}
                style={{
                  display: "flex", alignItems: "center", gap: 6,
                  height: 34, padding: isMobile ? "0 10px" : "0 14px",
                  borderRadius: 8, cursor: "pointer",
                  border: tab === "closed" ? "1px solid #5B2D8E" : "1px solid rgba(91,45,142,0.18)",
                  background: tab === "closed" ? "linear-gradient(135deg, rgba(91,45,142,0.15), rgba(91,45,142,0.10))" : "transparent",
                  color: tab === "closed" ? "#5B2D8E" : (theme.mode === "dark" ? "#64748b" : "#94a3b8"),
                  boxShadow: tab === "closed" ? "0 2px 8px rgba(91,45,142,0.18)" : "none",
                  transition: "all 0.2s", userSelect: "none",
                }}
                onMouseEnter={e => { if (tab !== "closed") { e.currentTarget.style.borderColor = "#5B2D8E"; e.currentTarget.style.color = "#5B2D8E"; e.currentTarget.style.background = "rgba(91,45,142,0.06)"; }}}
                onMouseLeave={e => { if (tab !== "closed") { e.currentTarget.style.borderColor = "rgba(91,45,142,0.18)"; e.currentTarget.style.color = theme.mode === "dark" ? "#64748b" : "#94a3b8"; e.currentTarget.style.background = "transparent"; }}}
              >
                <CheckBoxIcon style={{ fontSize: 16, color: "inherit" }} />
                <span style={{ fontSize: 13, fontWeight: 600, color: "inherit", lineHeight: 1 }}>Resueltos</span>
              </div>
            </Tooltip>
          </div>

          {/* ── ZONA DERECHA (flex:1, end) — Filtros + Nuevo ── */}
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4 }}>

            {/* Ver todos / Míos */}
            <Can
              role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
              perform="tickets-manager:showall"
              yes={() => (
                <Tooltip title={showAllTickets ? "Ver solo los míos" : "Ver todos"} placement="bottom">
                  <div
                    onClick={() => setShowAllTickets((p) => !p)}
                    style={{
                      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                      height: 32, padding: "0 8px", borderRadius: 8, cursor: "pointer", gap: 1,
                      border: showAllTickets ? "1px solid #5B2D8E" : "1px solid rgba(91,45,142,0.18)",
                      background: showAllTickets ? "rgba(91,45,142,0.10)" : "transparent",
                      color: showAllTickets ? "#5B2D8E" : (theme.mode === "dark" ? "#64748b" : "#94a3b8"),
                      transition: "all 0.2s",
                    }}
                  >
                    {showAllTickets
                      ? <VisibilityIcon style={{ fontSize: 14, color: "inherit" }} />
                      : <VisibilityOffIcon style={{ fontSize: 14, color: "inherit" }} />}
                    <span style={{ fontSize: 8, fontWeight: 700, color: "inherit", lineHeight: 1, whiteSpace: "nowrap" }}>
                      {showAllTickets ? "Todos" : "Míos"}
                    </span>
                  </div>
                </Tooltip>
              )}
            />

            {/* Ordenar */}
            {tab !== "closed" && tab !== "search" && (
              <Tooltip title={sortTickets ? "Más antiguos primero" : "Más recientes primero"} placement="bottom">
                <div
                  onClick={() => setSortTickets((p) => !p)}
                  style={{
                    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                    height: 32, padding: "0 8px", borderRadius: 8, cursor: "pointer", gap: 1,
                    border: sortTickets ? "1px solid #5B2D8E" : "1px solid rgba(91,45,142,0.18)",
                    background: sortTickets ? "rgba(91,45,142,0.10)" : "transparent",
                    color: sortTickets ? "#5B2D8E" : (theme.mode === "dark" ? "#64748b" : "#94a3b8"),
                    transition: "all 0.2s",
                  }}
                >
                  {sortTickets
                    ? <TextRotationDown style={{ fontSize: 14, color: "inherit" }} />
                    : <TextRotateUp style={{ fontSize: 14, color: "inherit" }} />}
                  <span style={{ fontSize: 8, fontWeight: 700, color: "inherit", lineHeight: 1 }}>
                    {sortTickets ? "Ant." : "Rec."}
                  </span>
                </div>
              </Tooltip>
            )}

            {/* Nuevo ticket */}
            <Tooltip title="Nuevo ticket" placement="bottom">
              <div
                onClick={() => setNewTicketModalOpen(true)}
                style={{
                  display: "flex", alignItems: "center", gap: 6,
                  height: 34, padding: isMobile ? "0 10px" : "0 14px",
                  borderRadius: 8, cursor: "pointer",
                  background: "linear-gradient(135deg, #5B2D8E, #7C3AED)",
                  color: "#fff", userSelect: "none",
                  transition: "opacity 0.2s, transform 0.2s",
                }}
                onMouseEnter={e => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "translateY(-1px)"; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "translateY(0)"; }}
              >
                <AddIcon style={{ fontSize: 17, color: "#fff" }} />
                {!isMobile && <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", lineHeight: 1 }}>Nuevo</span>}
              </div>
            </Tooltip>
          </div>

        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={i18n.t("tickets.inbox.closedAllTickets")}
        ContentProps={{ className: classes.snackbar }}
        action={
          <>
            <Button className={classes.yesButton} size="small" onClick={CloseAllTicket}>
              {i18n.t("tickets.inbox.yes")}
            </Button>
            <Button className={classes.noButton} size="small" onClick={handleSnackbarClose}>
              {i18n.t("tickets.inbox.no")}
            </Button>
          </>
        }
      />

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" direction="row" wrap="nowrap" style={{ position: "relative", paddingTop: 10, gap: 4 }}>
                <Grid item style={{ flexShrink: 0 }}>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={openCount}
                    color="primary"
                  >
                    <MessageSharpIcon
                      style={{
                        fontSize: isMobile ? 16 : 18,
                        color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: isMobile ? 10 : 11,
                      fontWeight: tabOpen === "open" ? 700 : 500,
                      color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {isMobile ? "Activos" : i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" direction="row" wrap="nowrap" style={{ position: "relative", paddingTop: 10, gap: 4 }}>
                <Grid item style={{ flexShrink: 0 }}>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={pendingCount}
                    color="primary"
                  >
                    <ClockIcon
                      style={{
                        fontSize: isMobile ? 16 : 18,
                        color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: isMobile ? 10 : 11,
                      fontWeight: tabOpen === "pending" ? 700 : 500,
                      color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {isMobile ? "Espera" : i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" direction="row" wrap="nowrap" style={{ position: "relative", paddingTop: 10, gap: 4 }}>
                  <Grid item style={{ flexShrink: 0 }}>
                    <Badge
                      overlap="circular"
                      max={999}
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                    >
                      <Group
                        style={{
                          fontSize: isMobile ? 16 : 18,
                          color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        fontSize: isMobile ? 10 : 11,
                        fontWeight: tabOpen === "group" ? 700 : 500,
                        color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        transition: "all 0.2s ease",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper} elevation={0} style={{ background: "transparent" }}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
            />
          )}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;